/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Swal_Single_TextInputs */

const en_merge_swal_single_text = /** @type {(inputs: Merge_Swal_Single_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would you like to merge the selected event with the event before or after it?`)
};

const fr_merge_swal_single_text = /** @type {(inputs: Merge_Swal_Single_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souhaitez-vous fusionner l'evenement selectionne avec l'evenement precedent ou suivant ?`)
};

const de_merge_swal_single_text = /** @type {(inputs: Merge_Swal_Single_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie das ausgewählte Ereignis mit dem vorhergehenden oder dem nachfolgenden Ereignis zusammenführen?`)
};

const it_merge_swal_single_text = /** @type {(inputs: Merge_Swal_Single_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desideri unire l'evento selezionato con quello precedente o successivo?`)
};

const ru_merge_swal_single_text = /** @type {(inputs: Merge_Swal_Single_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы хотите объединить выбранное событие с событием, предшествующим или следующим за ним?`)
};

const es_merge_swal_single_text = /** @type {(inputs: Merge_Swal_Single_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quieres fusionar el evento seleccionado con el evento anterior o posterior?`)
};

const zh_cn2_merge_swal_single_text = /** @type {(inputs: Merge_Swal_Single_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您想将选定的事件与其前一个事件还是后一个事件合并？`)
};

const ja_merge_swal_single_text = /** @type {(inputs: Merge_Swal_Single_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントをその前または後のイベントと結合しますか?`)
};

const hi_merge_swal_single_text = /** @type {(inputs: Merge_Swal_Single_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप चयनित इवेंट को उससे पहले या बाद वाले इवेंट के साथ मर्ज करना चाहेंगे?`)
};

const pt_pt2_merge_swal_single_text = /** @type {(inputs: Merge_Swal_Single_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deseja mesclar o evento selecionado com o evento anterior ou posterior?`)
};

/**
* | output |
* | --- |
* | "Would you like to merge the selected event with the event before or after it?" |
*
* @param {Merge_Swal_Single_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_swal_single_text = /** @type {((inputs?: Merge_Swal_Single_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Swal_Single_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_swal_single_text(inputs)
	if (locale === "de") return de_merge_swal_single_text(inputs)
	if (locale === "it") return it_merge_swal_single_text(inputs)
	if (locale === "ru") return ru_merge_swal_single_text(inputs)
	if (locale === "es") return es_merge_swal_single_text(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_swal_single_text(inputs)
	if (locale === "ja") return ja_merge_swal_single_text(inputs)
	if (locale === "hi") return hi_merge_swal_single_text(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_swal_single_text(inputs)
	return en_merge_swal_single_text(inputs)
});